import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { PropTypes } from "prop-types";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: "17px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "200px",
    gap: "1rem",
    cursor: "pointer",
    "& img": {
      width: "25%",
    },
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.main,
  },
  secondary: {
    backgroundColor: theme.palette.secondary.main,
    color: "#fff",
  },
  disabled: {
    backgroundColor: theme.palette.disabled.main,
    color: "#fff",
    cursor: "auto",
  },
}));

export default function ButtonIconComponent({ title, icon, action, disabled, secondary }) {
  const classes = useStyles();

  const classesStyles = `${classes.paper} ${secondary ? classes.secondary : classes.primary} ${
    disabled ? classes.disabled : ""
  }`;

  return (
    <div className={classesStyles} onClick={disabled ? void 0 : action}>
      <img src={icon} alt={"icon"} />
      {title}
    </div>
  );
}

ButtonIconComponent.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
};

ButtonIconComponent.defaultProps = {
  disabled: false,
  secondary: false,
};
